<script>
import { resolve } from "$app/paths";
import { page } from "$app/state";

import { DarkMode, SocialLinks, LanguageSwitcher } from "$lib/components";
import { footerBottomNavigations, footerNavigations } from "$lib/data";
import { cn } from "$lib/utils";
import { isActivePath, isExternal } from "$lib/utils";

// import { PUBLIC_SITE_NAME, PUBLIC_FOOTER_COPYRIGHT } from "$env/static/public";
// console.log("footerBottomNavigations", footerBottomNavigations);

import { FooterCopyright } from "./index";

// const _container = cn(
//   "mx-auto",
//   "w-full",
//   "max-w-[85rem]",
//   "px-4",
//   "py-6",
//   "sm:px-6",
//   "lg:px-8",
// );

const linkLi = cn(
  "relative",
  "inline-block",
  "pe-4",
  "before:absolute",
  "before:end-0",
  "before:top-1/2",
  "before:-translate-y-1/2",
  "before:text-base-12",
  "before:text-2xl",
  "before:content-['·']",
  "last:pe-0",
  "last-of-type:before:hidden",
);

// Footer Navigation Links
const link = cn(
  "inline-flex",
  "transition",
  "gap-x-2",
  "text-sm",
  "transition",
  "text-high-contrast",
  // "hover:text-base-11",
  "hover:opacity-75",
  "focus:text-base-11",
  "focus:outline-none",
  // "dark:text-neutral-500",
  // "dark:hover:text-neutral-200",
  // "dark:focus:text-neutral-200",
);

// const isActivePath = (href) => {
//   return $page.url.pathname == href || $page.url.pathname == href + "/";
// };
// $: isExternal = (href) => /^https?:\/\//.test(href);
</script>

<!-- Footer -->
<footer class="dark relative mt-auto overflow-hidden bg-black py-10">
  <svg
    class="absolute start-1/2 -bottom-20 z-0 w-[1900px] -translate-x-1/2 transform"
    width="2745"
    height="488"
    viewBox="0 0 2745 488"
    fill="none"
    aria-label="Footer background"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 330.864C232.505 403.801 853.749 527.683 1482.69 439.719C2111.63 351.756 2585.54 434.588 2743.87 487"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 308.873C232.505 381.81 853.749 505.692 1482.69 417.728C2111.63 329.765 2585.54 412.597 2743.87 465.009"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 286.882C232.505 359.819 853.749 483.701 1482.69 395.738C2111.63 307.774 2585.54 390.606 2743.87 443.018"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 264.891C232.505 337.828 853.749 461.71 1482.69 373.747C2111.63 285.783 2585.54 368.615 2743.87 421.027"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 242.9C232.505 315.837 853.749 439.719 1482.69 351.756C2111.63 263.792 2585.54 346.624 2743.87 399.036"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 220.909C232.505 293.846 853.749 417.728 1482.69 329.765C2111.63 241.801 2585.54 324.633 2743.87 377.045"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 198.918C232.505 271.855 853.749 395.737 1482.69 307.774C2111.63 219.81 2585.54 302.642 2743.87 355.054"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 176.927C232.505 249.864 853.749 373.746 1482.69 285.783C2111.63 197.819 2585.54 280.651 2743.87 333.063"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 154.937C232.505 227.873 853.749 351.756 1482.69 263.792C2111.63 175.828 2585.54 258.661 2743.87 311.072"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 132.946C232.505 205.882 853.749 329.765 1482.69 241.801C2111.63 153.837 2585.54 236.67 2743.87 289.082"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 110.955C232.505 183.891 853.749 307.774 1482.69 219.81C2111.63 131.846 2585.54 214.679 2743.87 267.091"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 88.9639C232.505 161.901 853.749 285.783 1482.69 197.819C2111.63 109.855 2585.54 192.688 2743.87 245.1"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 66.9729C232.505 139.91 853.749 263.792 1482.69 175.828C2111.63 87.8643 2585.54 170.697 2743.87 223.109"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 44.9819C232.505 117.919 853.749 241.801 1482.69 153.837C2111.63 65.8733 2585.54 148.706 2743.87 201.118"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 22.991C232.505 95.9276 853.749 219.81 1482.69 131.846C2111.63 43.8824 2585.54 126.715 2743.87 179.127"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
    <path
      d="M0.5 1C232.505 73.9367 853.749 197.819 1482.69 109.855C2111.63 21.8914 2585.54 104.724 2743.87 157.136"
      class="stroke-neutral-700/50"
      stroke="currentColor"
    ></path>
  </svg>

  <div class="relative z-10">
    <div class="container mb-4">
      <div class="flex flex-wrap items-center justify-between gap-5">
        <ul class="flex flex-wrap items-center gap-x-2 gap-y-1 text-center">
          {#each footerNavigations.items as { href, title }, index ((index, title))}
            <li class={linkLi}>
              <a
                class={link}
                href={resolve(href)}
                class:opacity-75={isActivePath(page, href)}
                aria-current={isActivePath(page, href) ? "page" : undefined}
              >
                {title}
              </a>
            </li>
          {/each}
        </ul>
        <div class="flex items-center space-x-2 md:text-end">
          <SocialLinks>
            <DarkMode class="inline" />
          </SocialLinks>
        </div>
      </div>
    </div>

    <FooterCopyright>
      <ul class="flex flex-wrap items-center gap-x-2 gap-y-0 text-center">
        {#each footerBottomNavigations as { href, title }, index ((index, title))}
          <li class={linkLi}>
            <a
              class={cn(link, "text-xs")}
              href={href}
              target={isExternal(href) ? "_blank" : undefined}
              rel={isExternal(href) ? "noopener noreferrer" : undefined}
              class:opacity-75={isActivePath(page, href)}
              aria-current={isActivePath(page, href) ? "page" : undefined}
            >
              {title}
            </a>
          </li>
        {/each}
      </ul>
    </FooterCopyright>
    <LanguageSwitcher class="mx-auto mt-4 flex w-full justify-center" />
  </div>
</footer>
<!-- End Footer -->
